import MRWidgetService from 'ee/vue_merge_request_widget/services/mr_widget_service';

export default MRWidgetService;
